// import { StrictMode } from 'react';
import { Amplify } from 'aws-amplify';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { GlobalStyle } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RecoilRoot } from 'recoil';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - - On the pipeline, npm run type:check, this file does not exist
import amplifyconfig from './amplifyconfiguration.json';
import App from './App';
import './assets/css/App.css';
// css imports
// TODO: remove this and use styled components
import './assets/css/fonts.css';
import './assets/css/index.css';
import './config/i18n';
import { initGA } from './features/analytic/analytics.js';
import { store } from './store/Store';
import APP_CONSTANTS from './utils/constants/app.constants';
import { IsLocalHost } from './utils/helpers/isLocalHost';

// --------------------- sentry ------------------------
const environment = APP_CONSTANTS.ENVIRONNEMENT;
if (environment !== 'local') {
  Sentry.init({
    dsn: 'https://630c9fcda3834c8bab3d1869900cd527@o1072557.ingest.sentry.io/6071599',
    integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
    environment,
    // eslint-disable-next-line no-undef
    release: import.meta.env.VITE_VERSION,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.5,
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: environment === 'simulation' ? 0.01 : 0.2,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: environment === 'simulation' ? 0.01 : 1.0,
  });
}

if (!IsLocalHost()) {
  // Initialize Google Analytics once when app loads
  initGA();
}

// --------------------- amplify ------------------------
// ALLOW local mocking of subscriptions to work. when upgrading from @aws-amplify/api v5.4.9 --> v5.4.16
// a change to the subscriptions was made and now we need proxies to change the way we connect to our
// local "amplify mock api" server
if (amplifyconfig.aws_appsync_graphqlEndpoint === 'http://127.0.0.1:20002/graphql') {
  console.warn('/// Using API mock server ///');
  amplifyconfig.aws_appsync_graphqlEndpoint = 'https://localhost:3333/api_local/graphql';
}

Amplify.configure({
  ...amplifyconfig,
});

// ---------------------token refresh-------------------
// Auth.configure({
//   oauth: {
//     scope: ['email', 'openid'],
//     refreshHandlers: {
// Automatically refresh the token 5 minutes before it expires

// NOTE: I am removing this because I don't think we use this but I am not confident so I keep it in the codebase
// in case I need to bring it back after testing

// [awsExports.oauth.redirectSignIn]: async () => {
//   console.log('refreshing token ?');
//   const refreshedSession = await Auth.currentSession();
//   return {
//     accessToken: refreshedSession.getAccessToken().getJwtToken(),
//     idToken: refreshedSession.getIdToken().getJwtToken(),
//     refreshToken: refreshedSession.getRefreshToken().getToken(),
//     expiresIn: refreshedSession.getAccessToken().payload.exp,
//   };
// },
//     },
//   },
// });

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 90000,
      retry: 1,
      enabled: true,
    },
  },
});

// --------------------- render ------------------------

createRoot(document.getElementById('root') as HTMLElement).render(
  // TODO: strictmode must be disabled to avoid warnings from Antd Animation.
  // We must wait for antd to upgrade and remove the use of "findByNode", or we can migrate all antd components to another library.
  // <StrictMode>
  <RecoilRoot>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <GlobalStyle />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </QueryClientProvider>
  </RecoilRoot>
  // </StrictMode>
);
